<script setup lang="ts">
import { InputProps, InputEvents } from "@/cms/inputs/Input/Input.types.ts";
import InputWrapper from "@/cms/inputs/shared/InputWrapper.vue";
import { Input } from "@/cms/components/ui/input/index.ts";
import { computed } from "vue";

const props = defineProps<InputProps>();
defineEmits<InputEvents>();

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<string | number>({ required: true });

function clearDefaults() {
  if (props.autoClearValue && model.value === props.autoClearValue) {
    model.value = "";
  }
}

const getDataDdLabel = computed(() =>
  props.dataDd ? props.dataDd : `CMS Input: ${props.label}`
);
</script>

<template>
  <InputWrapper :error :help :label :info v-bind="$attrs" :field-id="id">
    <Input
      v-bind="$attrs"
      :id
      v-model="model"
      :data-dd="getDataDdLabel"
      @blur="$emit('blur', $event)"
      @click="clearDefaults"
    />
  </InputWrapper>
</template>
